module.exports = __webpack_public_path__ + "img/sixpackcarrier15.c57145a5.jpg";